
import apiService from '../Services/ApiService';
import AppConfig from "../Configuration/AppConfig";

class UserService {
  constructor() {
    this.groupsCache = null;
    this.userPhotoCache = null;
    this.userPhotoCached = false;
    this.callbackPrefProjects = [];
    this.userPrefProjectsCache = null;
    this.hasConsentCompuInstanceCache = null;
    this.consentCompuInstanceUri = null;
    this.hasAppConsentCache = null;
  }

  IsUserAdmin() {
    return this.GetGroups().then((groups) => groups.includes(AppConfig.CodaiGroups.CodaiAdminGroupName));
  }

  IsUserDataScientist() {
    return this.GetGroups().then((groups) => groups.includes(AppConfig.CodaiGroups.CodaiDataScientistGroupName));
  }

  searchUser(partialUpn) {
    return apiService.searchUser(partialUpn);
  }

  GetGroups() {
    if (!this.groupsCache) {
      this.groupsCache = apiService.userGroups();
    }
    return this.groupsCache;
  }

  GetPhoto() {
    if (!this.userPhotoCached) {
      return apiService.userPhoto().then(data => {
        this.userPhotoCache = data.photoDataUrl;
        this.userPhotoCached = true;
        return this.userPhotoCache;
      });
    }
    return this.userPhotoCache;
  }

  subscribePrefProjects(listener) {
    if (!listener) {
      console.error('PrefService: invalid listener!');
    }
    if (this.callbackPrefProjects.indexOf(listener) != -1) {
      console.error('PrefService: subscription duplicate found!');
    } else {
      this.callbackPrefProjects.push(listener);
    }
  }

  unsubscribePrefProjects(listener) {
    if (!listener) {
      console.error('PrefService: invalid listener!');
    }

    let listenerIdx = this.callbackPrefProjects.indexOf(listener);
    if (listenerIdx < 0) {
      console.error('PrefService: unsubscribe listener not found!');
    } else {
      this.callbackPrefProjects.splice(listenerIdx, 1);
    }
  }

  notifySubscribersPrefProjects() {
    this.callbackPrefProjects.forEach((listener) => listener());
  }

  async GetPrefProjects() {
    if (!this.userPrefProjectsCache) {
      var objects = await apiService.getUserPrefProjects();
      this.userPrefProjectsCache = objects.map(rel => rel.projectId);
    }
    return this.userPrefProjectsCache;
  }
  IsPrefProject(projectId) {
    return this.GetPrefProjects().then(lstProj => { return lstProj.indexOf(projectId) !== -1; });
  }


  AddPrefProjects(projectId) {

    return this.GetPrefProjects()
      .then(() => {
        return apiService.addUserPrefProjects(projectId);
      })
      .then(() => {
        if (this.userPrefProjectsCache.indexOf(projectId) === -1) {
          this.userPrefProjectsCache.push(projectId);
          this.notifySubscribersPrefProjects();
        }
      });
  }

  RemovePrefProjects(projectId) {

    return this.GetPrefProjects()
      .then(() => {
        return apiService.deleteUserPrefProjects(projectId);
      })
      .then(() => {
        let i = this.userPrefProjectsCache.indexOf(projectId);
        if (i !== -1) {
          this.userPrefProjectsCache.splice(i, 1);
          this.notifySubscribersPrefProjects();
        }
      });
  }

  async HasComputeInstanceConsent() {
    if (!this.hasConsentCompuInstanceCache) {
      let check = await apiService.checkUserAmlCIConsent();
      this.hasConsentCompuInstanceCache = check.hasConsent;
      this.consentCompuInstanceUri = check.missingConsentUri;
    }
    return this.hasConsentCompuInstanceCache;
  }

  async GetComputeInstanceConsentUri() {
    var check = await this.HasComputeInstanceConsent();
    if (!check) {
      return this.consentCompuInstanceUri;
    }
    return null;
  }
  ResetComputeInstanceConsentCache() {
    this.hasConsentCompuInstanceCache = null;
  }

  async HasAppConsent() {
    if (this.hasAppConsentCache == null) {
      let check = await apiService.checkUserCodaiConsent();
      this.hasAppConsentCache = check.hasConsent;
    }
    return this.hasAppConsentCache;
  }

  ResetAppConsentCache() {
    this.hasAppConsentCache = null;
  }

  async GrantAppConsent() {
    await apiService.grantUserCodaiConsent();
    this.hasAppConsentCache = true;
    return this.hasAppConsentCache;
  }
}

const userService = new UserService();

export default userService;
